import { veregy } from './veregy';

export const breakpoints = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920,
};

const defaultPalette = {
  primary: {
    main: veregy.colors.blue,
  },
  secondary: {
    main: veregy.colors.green,
  },
  warning: {
    main: veregy.colors.orange,
  },
  error: {
    main: veregy.colors.red,
  },
  skeleton: veregy.colors.lightgrey,
};

export const chartColor = (idx) => {
  const chartColors = [
    veregy.colors.blue,
    veregy.colors.green,
    veregy.colors.orange,
    veregy.colors.lightgrey,
    veregy.colors.purple,
  ];
  return chartColors[idx % chartColors.length];
};

export const muiTheme = {
  palette: defaultPalette,
  fontAwesomeIcon: {
    width: 40,
    height: 40,
  },
  typography: {
    fontFamily: veregy.font.family,
    defaultFontSize: '0.875rem',
    button: {
      textTransform: 'none',
    },
  },
  breakpoints: {
    keys: ['xs', 'sm', 'md', 'lg', 'xl'],
    values: breakpoints,
  },
  dialog: {
    form: {
      minWidth: '450px',
    },
  },
  veregy,
};
